import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { EmailDataContextProvider } from "../partials/dataContext";
import { ScreenContextProvider } from "../partials/screenContext";
import { ErrorContextProvider } from "../partials/errorContext";
import { Provider } from "react-redux";
import store from "../redux/store";

import "../styles/taskpane.scss";
/* global document, Office, module, require */

initializeIcons();

let isOfficeInitialized = false;

const title = "Companyapp";

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <ErrorContextProvider>
          <ScreenContextProvider>
            <EmailDataContextProvider>
              <Component title={title} isOfficeInitialized={isOfficeInitialized} />
            </EmailDataContextProvider>
          </ScreenContextProvider>
        </ErrorContextProvider>
      </Provider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;

  if (navigator?.userAgent?.indexOf("Trident") !== -1) {
    ReactDOM.render(
      <div
        id="tridentmessage"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          height: "100vh",
          width: "100vw",
        }}
      >
        This add-in will not run in your version of Office. Please upgrade either to perpetual Office 2021 (or later) or
        to a Microsoft 365 account.
      </div>,
      document.getElementById("container")
    );
  } else if (navigator.userAgent.indexOf("Edge") !== -1) {
    ReactDOM.render(
      <div
        id="tridentmessage"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          height: "100vh",
          width: "100vw",
        }}
      >
        This add-in won't run in your version of Office. Please upgrade either to perpetual Office 2021 (or later) or to
        a Microsoft 365 account
      </div>,
      document.getElementById("container")
    );
  } else {
    render(App);
  }
});

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
